import endpoints from "@config/endpoints";
import { getData } from "@services/CommonApiService";
import { errorLogger } from "@utils/applicationLogUtils";

export const getDeliveryOutcomeByPregnancyId = async (pregnancyId: any) => {
    try {
        if (!pregnancyId) {
            errorLogger("getDeliveryOutcomeByPregnancyId: pregnancyId is missing, API call skipped");
            return null;
        }

        const res = await getData<any>(`${endpoints.deliveryOutcome}/${pregnancyId}`);
        if (res && (res.data || res.data?.length > 0)) {
            return res;
        }
    } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error);
    }

    return null;
};